
/**
 * Returns the Apollo client from this
 *
 * @param self
 * @returns {any | ApolloClient<TCacheShape>}
 */
export const apolloClient = self => self.app.apolloProvider.defaultClient
